<template>
  <div class="container mt-4">
    <h3>CheckboxField Demo</h3>
    <CheckboxField
        v-model="agree"
        label="I agree to the terms and conditions"
    />

    <p class="mt-2">Checkbox value: <strong>{{ agree }}</strong></p>

    <CheckboxField
        v-model="disabledCheck"
        label="This checkbox is disabled"
        :disabled="true"
    />

    <h3>Checkboxes Demo</h3>
    <div v-for="col in columns" :key="col.key" class="mb-2">
      <CheckboxField
          :modelValue="checkedColumns.includes(col.key)"
          @update:modelValue="val => handleToggleColumn(col.key, val)"
          :label="col.title"
      />
    </div>

    <!-- Display checked columns -->
    <div class="mt-3">
      <strong>Checked columns:</strong> {{ checkedColumns.join(', ') || 'None' }}
    </div>


  <!-- Column with documentation -->
    <h3>Component Documentation</h3>
    <p>
      <strong>CheckboxField</strong> is a Vue 3 component for rendering checkboxes with <code>v-model</code> support.
      It generates a unique ID for each checkbox and supports disabling.
    </p>

    <h5>Props</h5>
    <ul>
      <li><code>modelValue</code> (Boolean) – two-way binding for checkbox state</li>
      <li><code>label</code> (String) – text displayed next to the checkbox</li>
      <li><code>disabled</code> (Boolean, default: false) – disables the checkbox when true</li>
    </ul>

    <h5>Events</h5>
    <ul>
      <li><code>update:modelValue</code> (Boolean) – emitted when checkbox state changes, used by v-model</li>
    </ul>

    <h5>Methods in Demo</h5>
    <ul>
      <li><code>handleToggleColumn(key, checked)</code> – updates <code>checkedColumns</code> array when a checkbox is toggled</li>
    </ul>


    <h3>Example Usage Code</h3>
    <pre class="p-2 bg-white text-dark">
        &lt;CheckboxField
          v-model="agree"
          label="I agree to the terms and conditions"
        /&gt;

        &lt;CheckboxField
          v-model="disabledCheck"
          label="This checkbox is disabled"
          :disabled="true"
        /&gt;

        &lt;div v-for="col in columns" :key="col.key"&gt;
          &lt;CheckboxField
            :modelValue="checkedColumns.includes(col.key)"
            @update:modelValue="val =&gt; handleToggleColumn(col.key, val)"
            :label="col.title"
          /&gt;
        &lt;/div&gt;

        columns: [
          { key: 1, title: 'text 1' },
          { key: 2, title: 'text 2' },
          { key: 3, title: 'text 3' },
          { key: 4, title: 'text 4' },
          { key: 5, title: 'text 5' }
        ]

        handleToggleColumn(key, checked) {
          if (checked) {
            this.checkedColumns.push(key)
          } else {
            this.checkedColumns = this.checkedColumns.filter(k =&gt; k !== key)
          }
        }
      </pre>
  </div>
</template>

<script>
import CheckboxField from "@/components/common/checkbox-field/CheckboxField.vue";

export default {
  name: "CheckboxFieldDemo",
  components: { CheckboxField },
  data() {
    return {
      checkedColumns: [],
      agree: false,
      disabledCheck: false,
      columns: [
        { key: 1, title: "text 1" },
        { key: 2, title: "text 2" },
        { key: 3, title: "text 3" },
        { key: 4, title: "text 4" },
        { key: 5, title: "text 5" },
      ],
    };
  },
  methods: {
    handleToggleColumn(key, checked) {
      if (checked) {
        this.checkedColumns.push(key);
      } else {
        this.checkedColumns = this.checkedColumns.filter((k) => k !== key);
      }
      console.log("Checked columns:", this.checkedColumns);
    },
  },
};
</script>